import {
    CHARTDESIGNER_DELETE_CHART
} from '~/frontend/src/constants';
import {
    StoreState,
    AppDispatch,
    Thunk
} from '~/frontend/src/store';

import {
    DeleteChartParameters,
    DeleteChartResult
} from '~/shared/src/utilities/modules/chart';
import {clearElusiveData} from '~/frontend/src/actions/elusiveData';
import xhr from '~/frontend/src/utilities/xhr';


/**
 * @memberOf! Actions
 *
 * @param {string} panelKey
 * @param {number} chartId
 * @param {( responseData : DeleteChartResult ) => void} [successCallback]
 *
 * @return {Promise<DeleteChartResult | false>}
 */
const deleteChart = ( panelKey : string, chartId : number, successCallback? : ( responseData : DeleteChartResult ) => void ) : Thunk<Promise<DeleteChartResult | false>> => async ( dispatch : AppDispatch, getState : () => StoreState ) : Promise<DeleteChartResult | false> => {
    dispatch( {
        type: CHARTDESIGNER_DELETE_CHART,
        panelKey,
        chartId
    } );

    let retVal : DeleteChartResult | false = false;

    dispatch( clearElusiveData( panelKey ) );

    const params : DeleteChartParameters = {
              viewId: chartId
          },
          response                          = await xhr.post(
              `${BASE_URL}/api/chart/deleteChart`,
              params,
              undefined,
              panelKey,
              'deleteChart',
              dispatch
          );

    if ( response?.data.success && !response.data.errorTitle ) {
        if ( successCallback ) {
            successCallback( response.data as DeleteChartResult );
        }

        retVal = response.data as DeleteChartResult;
    }

    return retVal;
};
export type DeleteChart = typeof deleteChart;

export default deleteChart;
